export const SESSION_KEYS = { TOKEN: 'w_t' };

export function isLogin() {
  const token = localStorage.getItem(SESSION_KEYS.TOKEN);
  return token !== '' && token !== 'null' && token !== null;
}

export function getToken() {
  return localStorage.getItem(SESSION_KEYS.TOKEN);
}

export function deleteToken() {
  localStorage.removeItem(SESSION_KEYS.TOKEN);
}

export function setToken(token: string) {
  localStorage.setItem(SESSION_KEYS.TOKEN, token);
}
